module.exports = __webpack_public_path__ + "img/delete.1967c2f2.png";